import React, { useContext } from 'react'
import { CashflowEventsContext } from '../../context'
import { EVENT_TYPES } from '../../reducer'
import { InfoSection } from '../../../../components/InfoSection'
import { EventForm } from './EventForm'
import { getFormEventTypeFromState } from '../../helpers/stateHelper'

export const EventFormScreen = () => {
  const { state } = useContext(CashflowEventsContext)
  const { infoImageSrc, expenseImageSrc, eventType } = state
  const imageSrc = eventType === 'expense'
    ? expenseImageSrc
    : infoImageSrc

  return (
    <section className='cashflow-events cashflow-events--background-grey'>
      <div className='cashflow-events__form app-form app-form--nested-in-card lg:grid lg:grid-cols-2'>
        <EventForm />
        <InfoSection>
          <InfoText />
          <img className='cashflow-dashboard-image' alt='cashflow-events' src={imageSrc} />
        </InfoSection>
      </div>
    </section>
  )
}

const InfoText = () => {
  const formEventType = getFormEventTypeFromState()
  if (formEventType === EVENT_TYPES.INCOME) {
    return <h3>Discover how additional income <strong>can grow your retirement.</strong></h3>
  } else if (formEventType === EVENT_TYPES.EXPENSE) {
    return <h3>Don't pay for your expenses, <strong>let your investment grow it for you.</strong></h3>
  }
}
